import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import useAuth from "./hooks/useAuth";
import { InactivityProvider } from "./Context/InactivityProvider";
import Preloader from "./shared/PreLoaders";
import ProtectedRoutes from "./ProtectedRoutes";
import Login from "./user-pages/Login";
import Lockscreen from "./user-pages/Lockscreen";
import ForgotPassword from "./user-pages/ForgotPassword";
import VfcFirstMainPage from "./dashboard/components/VfcFirstMainPage"
const AppRoutes = () => {
  return (
    <Suspense fallback={<Preloader />}>
      <Routes>
        {/* ✅ PUBLIC ROUTES */}
        <Route path="/" element={<VfcFirstMainPage />} />
        <Route path="/login-1" element={<Login />} />
        <Route path="/user-pages/forgot-password" element={<ForgotPassword />} />
        <Route path="/user-pages/lockscreen" element={<Lockscreen />} />

        {/* 🔐 PROTECTED ROUTES */}
        <Route
          path="/*"
          element={
            <InactivityProvider>
              <ProtectedRoutes />
            </InactivityProvider>
          }
        />
      </Routes>
    </Suspense>
  );
};


export default AppRoutes;
